import { render, staticRenderFns } from "./FinalGradeSelectReviewers.vue?vue&type=template&id=6b7f985c&scoped=true&"
import script from "./FinalGradeSelectReviewers.vue?vue&type=script&lang=js&"
export * from "./FinalGradeSelectReviewers.vue?vue&type=script&lang=js&"
import style0 from "./FinalGradeSelectReviewers.vue?vue&type=style&index=0&id=6b7f985c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f985c",
  null
  
)

export default component.exports